const $searchInput = $(".js-search-input");

let activeElement,
    isScrolling,
    navigation = {
        name: "navigation",
        trigger: $(".js-trigger-navigation"),
        elem: $(".js-target-navigation"),
        active: false,
        overlay: false,
        disabled: false,
        allowScroll: true,
        callback: {
            show: function () {
                showOverlay(250, !checkResolution("cxs;xs"));

                if (checkResolution("cxs;xs")) {
                    window.scrollTo(0, 0);
                }

                bLazy.revalidate();

                if (!checkResolution("cxs") && !$(".js-nav-categories-item.is-active").length) {
                    $(".js-nav-categories-item").eq(0).trigger("click");
                }

                // calculateNavContentBoxHeight();

                $(".js-nav-image-lazy:not(.is-loaded)").each(function () {
                    $(this).attr("src", $(this).data("src"));

                    $(this).addClass("is-loaded");
                });
            },
            hide: function () {
                hideOverlay();
            },
        },
    },
    account = {
        name: "account",
        trigger: $(".js-trigger-account"),
        elem: $(".js-target-account"),
        active: false,
        overlay: true,
        disabled: false,
        callback: false,
    },
    search = {
        name: "search",
        trigger: $(".js-trigger-search"),
        elem: $(".js-target-search"),
        active: false,
        overlay: true,
        disabled: false,
        callback: {
            show: function () {
                $(".l-header").addClass("has-search-open");

                setTimeout(function () {
                    $searchInput.focus();
                }, 100);
            },
            hide: function () {
                $(".l-header").removeClass("has-search-open");
            },
        },
    },
    minicart = {
        name: "minicart",
        trigger: $(".js-trigger-minicart"),
        elem: $(".js-target-minicart"),
        active: false,
        overlay: true,
        disabled: "cxs;xs",
        callback: {
            show: function () {
                if (!checkResolution("cxs;xs")) {
                    window.scrollTo(0, 0);
                }
            },
        },
    },
    aside = {
        name: "aside",
        trigger: $(".js-trigger-aside"),
        elem: $(".js-target-aside"),
        active: false,
        overlay: true,
        disabled: false,
        callback: {
            show: function () {
                window.scrollTo(0, 0);
            },
            hide: function () {},
        },
    };

function calculateNavContentBoxHeight(clearValues = false) {
    calculateSpecialListHeight({
        selector: ".js-nav-content-box.is-active",
        disabled: "cxs;xs",
        clearValues: clearValues,
    });
}

function activateSubmenu(row) {
    const $navItem = $(row),
        id = $navItem.data("id");

    $(".js-nav-content-box .js-nav-categories-item").removeClass("is-active");
    $('.js-nav-content-box[data-id="' + id + '"]').addClass("is-active");

    $navItem.addClass("is-active");

    bLazy.revalidate();

    // calculateNavContentBoxHeight();

    setTimeout(() => {
        bLazy.revalidate();

        // calculateNavContentBoxHeight();
    }, 50);
}

function deactivateSubmenu(row) {
    const $navItem = $(row),
        id = $navItem.data("id");

    $('.js-nav-content-box[data-id="' + id + '"]').removeClass("is-active");
    $navItem.removeClass("is-active");
}

rEvent.on("Autocomplete.show", function () {
    $("body").addClass("disabled-up-sell");

    setTimeout(function () {
        $(".js-stars").each(function () {
            createStars($(this), {
                readOnly: true,
                starSize: parseInt($(this).attr("data-size")) || 16,
            });
        });
    }, 250);
});

rEvent.on("Autocomplete.hide", function () {
    $("body").removeClass("disabled-up-sell");
});

$(function () {
    $(".rcrumbs").rcrumbs({
        ellipsis: false,
        nbUncollapsableCrumbs: 0,
        nbFixedCrumbs: 1,
        animation: {
            activated: false,
        },
    });

    // main nav and header elements
    $(".js-nav-categories").menuAim({
        activate: activateSubmenu,
        deactivate: deactivateSubmenu,
        rowSelector: ".js-nav-categories-item",
    });

    $(".js-nav-categories-item").on("click", function (event) {
        if (checkResolution("cxs;xs")) {
            event.preventDefault();
        }

        if (checkResolution("cxs")) {
            $(".navigation-main").addClass("is-asided");
        }
    });

    $(".js-nav-categories-item")
        .on("touchstart", function () {
            isScrolling = false;
        })
        .on("touchmove", function (e) {
            isScrolling = true;
        })
        .on("touchend", function (e) {
            if (!isScrolling && checkResolution("cxs")) {
                $(".navigation-main").addClass("is-asided");
            }
        });

    $(".js-close-subnavigation").on("click", function (event) {
        event.preventDefault();

        $(".navigation-main").removeClass("is-asided");
    });

    for (const object of [navigation, account, minicart, aside]) {
        object.trigger.on("click", function (event) {
            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            } else {
                hideElem(object);
            }
        });
    }

    search.trigger.on("click", function (event) {
        if (!(activeElement == search && activeElement.active)) {
            showElem(search);
        }
    });

    $(".js-close-search").on("click", function (e) {
        e.preventDefault();

        hideElem(search);
    });

    $("body").on("click", function (event) {
        if (activeElement && activeElement.active) {
            if (
                !$(event.target).closest(activeElement.elem).length &&
                !$(event.target).closest(activeElement.trigger).length
            ) {
                hideElem(activeElement);
            }
        }
    });

    $("body").on("keypress", ".header-search .c-form__input", function (event) {
        if ($(this).val() && event.which === 13) {
            const url = "/vyhladavanie?search=" + $(this).val();

            window.location.href = url;
        }
    });

    // toggle password
    $(".js-toggle-password").on("click", function () {
        const $this = $(this),
            $input = $this.parent().find(".c-form__input"),
            type = $input.attr("type");

        if (type == "text") {
            $input.attr("type", "password");
        } else {
            $input.attr("type", "text");
        }
    });

    // $(window).on('resize', function() {
    // calculateNavContentBoxHeight(true);
    // });
});
